// Safe mount point for the new payout redemption journey (plan §12).
//
// Renders NOTHING when the payout domain is off/unavailable (the default, and prod),
// so the existing legacy wallet UI is 100% untouched until the domain is enabled in an
// isolated synthetic environment. When enabled, it surfaces the shared RedemptionsPanel
// (history + status/timeline + cancel) driven entirely by the server contract.
//
// STATUS: SCAFFOLDED — pending visual QA (desktop + mobile) in an enabled synthetic env.
import React from "react";
import { usePayoutOptions, isDomainOff } from "@/components/payouts/usePayouts";
import RedemptionsPanel from "@/components/payouts/RedemptionsPanel";

export default function PayoutDomainSection({ compact = false }) {
  const { options, error, loading, reload } = usePayoutOptions();
  if (loading) return null;
  // Domain OFF (503) → render nothing (legacy wallet unchanged). A NON-503 failure means
  // the domain is enabled but erroring: show an honest retry state (never fall back to the
  // legacy withdrawal path).
  if (error) {
    if (isDomainOff(error)) return null;
    return (
      <section className={compact ? "" : "rounded-xl border border-surface-border p-5"}>
        <div className="flex items-center justify-between gap-3 rounded-[12px] border border-[#1F1F23] bg-[#0C0C0E] p-3 text-[13px] text-[#a1a1aa]">
          <span>Redemptions are temporarily unavailable. Your balance is safe.</span>
          <button className="rounded-[8px] px-3 py-1 text-[12px] font-semibold"
            style={{ backgroundColor: "#141417", color: "#e4e4e7" }} onClick={reload}>
            Retry
          </button>
        </div>
      </section>
    );
  }
  if (!options) return null;
  return (
    <section id="payout-redemptions" className={compact ? "" : "rounded-xl border border-surface-border p-5"}>
      <div className="mb-3 text-[13px] font-semibold uppercase tracking-[.12em] text-[#71717a]">
        Cash redemptions
      </div>
      <RedemptionsPanel />
    </section>
  );
}
